import { scalpert } from '../../../lib/scalpert.cls';
var Const = /** @class */ (function () {
    function Const() {
    }
    // log tag
    Const.TAG = 'TRADING';
    /*************************************************
    ////// store method hooks from here //////
    **************************************************/
    Const.RUN_TRADER_LOGIN = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_TRADER_LOGIN';
    Const.RUN_PLACE_BRACKET_ORDER = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_PLACE_BRACKET_ORDER';
    Const.RUN_SQUARE_OFF = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_SQUARE_OFF';
    Const.RUN_PARTIAL_POSITION = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_PARTIAL_POSITION';
    Const.RUN_MODIFY_ORDER = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_MODIFY_ORDER';
    Const.RUN_GET_PAYIN_LINK = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_PAYIN_LINK';
    Const.RUN_GET_PAY_OUT = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_PAY_OUT';
    Const.RUN_GET_CHART_DATA = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_CHART_DATA';
    Const.SET_OPEN_HOLDINGS = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_OPEN_HOLDINGS';
    Const.RUN_ORDER_REQUIRED_DETAIL = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_ORDER_REQUIRED_DETAIL';
    Const.RUN_EXIT_COVER_ORDER = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_EXIT_COVER_ORDER';
    Const.RUN_EXIT_BRACKET_ORDER = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_EXIT_BRACKET_ORDER';
    Const.RUN_GET_USER_INFO = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_USER_INFO';
    Const.RUN_GET_EXCHANGE_MSG = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_EXCHANGE_MSG';
    Const.SET_MARKET_DEPTH = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_MARKET_DEPTH';
    Const.GET_TRADERING_INFO = 'GET_TRADERING_INFO';
    Const.GET_TRADER_BASIC_INFO = 'GET_TRADER_BASIC_INFO';
    Const.GET_HISTORY = 'GET_HISTORY';
    Const.SET_TRADER_BASIC_INFO = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_TRADER_BASIC_INFO';
    Const.SET_TRADERING_INFORMATION = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_TRADERING_INFORMATION';
    Const.SET_ORDER_HISTORY = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_ORDER_HISTORY';
    Const.SET_BONUS_HISTORY = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_BONUS_HISTORY';
    Const.RUN_GET_TRADERING_INFO = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_TRADERING_INFO';
    Const.RUN_GET_USER_LOGS = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_USER_LOGS';
    Const.RUN_GET_TRADERING_INFO_SOCKET = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_TRADERING_INFO_SOCKET';
    Const.RUN_GET_HISTORY = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_HISTORY';
    Const.RUN_USER_LOGOUT = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_USER_LOGOUT';
    Const.GET_QR_CODE = 'GET_QR_CODE';
    Const.SET_QR_CODE = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_QR_CODE';
    Const.SET_USER_LOGS = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_USER_LOGS';
    Const.SET_LOADER_STATUS = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_LOADER_STATUS';
    Const.RUN_TWO_FACTOR_AUTH = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_TWO_FACTOR_AUTH';
    Const.RUN_VERIFICATION_AUTH_TOKEN = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_VERIFICATION_AUTH_TOKEN';
    Const.RUN_GET_BANKS_DETAIL = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_BANKS_DETAIL';
    Const.RUN_UPDATE_USER_INFO = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_UPDATE_USER_INFO';
    Const.RUN_BUY_SELL_TRADE = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_BUY_SELL_TRADE';
    Const.RUN_GET_ORDER_HISTORY = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_ORDER_HISTORY';
    Const.RUN_UPLOAD_INDIVIDUAL_ACCOUNT = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_UPLOAD_INDIVIDUAL_ACCOUNT';
    Const.RUN_GET_TICKET_VIEW = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_TICKET_VIEW';
    Const.RUN_UPLOAD_CORPORATE_ACCOUNT = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_UPLOAD_CORPORATE_ACCOUNT';
    Const.RUN_GET_DOCUMENT_LIST = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_DOCUMENT_LIST';
    Const.RUN_BUY_SELL_MARKET = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_BUY_SELL_MARKET';
    Const.RUN_DELETE_ORDER = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_DELETE_ORDER';
    Const.RUN_CLOSE_TRADE = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_CLOSE_TRADE';
    Const.RUN_GET_OPEN_ORDER = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_OPEN_ORDER';
    Const.RUN_GET_DEPOSIT_HISTORY = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_DEPOSIT_HISTORY';
    Const.RUN_GET_BONUS_HISTORY = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_BONUS_HISTORY';
    Const.RUN_GET_TRADERING_ID = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_TRADERING_ID';
    Const.RUN_GET_MARGIN_INFO = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_MARGIN_INFO';
    Const.RUN_SEND_WITHDRAWAL_REQUEST = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_SEND_WITHDRAWAL_REQUEST';
    Const.RUN_GET_CARDS_LIST = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_CARDS_LIST';
    Const.RUN_SAVE_BANK_DETAIL = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_SAVE_BANK_DETAIL';
    Const.RUN_GENRATE_OTP = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GENRATE_OTP';
    Const.SET_INERTVAL = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_INERTVAL';
    Const.SET_TRADING_ACCOUNT = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_TRADING_ACCOUNT';
    Const.SET_ORDER_HISTROY = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_ORDER_HISTROY';
    Const.SET_OPEN_POSITION = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_OPEN_POSITION';
    Const.RUN_GET_DASHBOARD_DATA = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_DASHBOARD_DATA';
    Const.RUN_GET_WITHDRAWAL_HISTORY = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_WITHDRAWAL_HISTORY';
    Const.RUN_GET_TICKET_LIST = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_TICKET_LIST';
    Const.RUN_SAVE_TICKET = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_SAVE_TICKET';
    Const.RUN_CREATE_LIVE_ACCOUNT = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_CREATE_LIVE_ACCOUNT';
    Const.RUN_UDPATE_ACCOUNT_OPERATION = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_UDPATE_ACCOUNT_OPERATION';
    Const.RUN_GET_SCRIP_INFO = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_SCRIP_INFO';
    Const.RUN_TRADER_REGISTER = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_TRADER_REGISTER';
    Const.RUN_VERIFY_OTP = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_VERIFY_OTP';
    Const.RUN_CREATE_DEMO_ACCOUNT = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_CREATE_DEMO_ACCOUNT';
    Const.RUN_UPDATE_PROFILE = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_UPDATE_PROFILE';
    Const.RUN_GET_CALLBACK_ADDRESS = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_CALLBACK_ADDRESS';
    Const.RUN_GET_ADD_CARD = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_ADD_CARD';
    Const.RUN_UPLOAD_DOCUMENT = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_UPLOAD_DOCUMENT';
    Const.SET_EXCHANGE_MSG = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_EXCHANGE_MSG';
    Const.SET_CLOSED_ORDER = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_CLOSED_ORDER';
    Const.SET_MARGIN_INFO = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_MARGIN_INFO';
    Const.SET_DEPOSIT_HISTORY = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_DEPOSIT_HISTORY';
    Const.SET_WITHDRAWAL_HISTORY = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_WITHDRAWAL_HISTORY';
    Const.SET_BANKS_DETAIL = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_BANKS_DETAIL';
    Const.SET_CARDS_LIST = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_CARDS_LIST';
    Const.SET_SOCKET_INDICATOR = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/ SET_SOCKET_INDICATOR';
    Const.SET_TICKET_LIST = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_TICKET_LIST';
    Const.SET_DOCUMENT_LIST = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_DOCUMENT_LIST';
    Const.SET_TICKET_VIEW_LIST = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_TICKET_VIEW_LIST';
    Const.SET_DEPOSIT_ADDRESS = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_DEPOSIT_ADDRESS';
    Const.SET_GRAPH_DATA = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_GRAPH_DATA';
    Const.SET_CURRENT_TRADING_ACCOUNT = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_CURRENT_TRADING_ACCOUNT';
    Const.SET_OPEN_ORDER = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_OPEN_ORDER';
    Const.SET_USER_EXTRA_INFO = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_USER_EXTRA_INFO';
    Const.SET_ALL_ISINS = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_ALL_ISINS';
    Const.SET_MARKET_STATUS = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_MARKET_STATUS';
    Const.SET_SCRIP_INFO = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_SCRIP_INFO';
    Const.SET_WATCH_LIST = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/SET_WATCH_LIST';
    Const.RUN_GET_ALL_ISINS = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_ALL_ISINS';
    Const.RUN_OPTION_CALCULATOR = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_OPTION_CALCULATOR';
    Const.RUN_VERIFICATION_AUTH_TOKEN_ONE_TIME = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_VERIFICATION_AUTH_TOKEN_ONE_TIME';
    Const.RUN_TRADER_SOCIAL_LOGIN = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_TRADER_SOCIAL_LOGIN';
    Const.RUN_TRADER_FACEBOOK_SIGNUP = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_TRADER_FACEBOOK_SIGNUP';
    Const.RUN_GET_DEPOSIT_ADDRESS = scalpert.STORE_MODULE_NAME + '/' + Const.TAG +
        '/RUN_GET_DEPOSIT_ADDRESS';
    Const.GET_LOADER_STATUS = 'GET_LOADER_STATUS';
    Const.GET_OPEN_POSITION = 'GET_OPEN_POSITION';
    Const.GET_CLOSED_ORDER = 'GET_CLOSED_ORDER';
    Const.GET_TRADING_ACCOUNT = 'GET_TRADING_ACCOUNT';
    Const.GET_INTERVAL = 'GET_INTERVAL';
    Const.GET_MARGIN = 'GET_MARGIN';
    Const.GET_DEPOSIT_HISTORY = 'GET_DEPOSIT_HISTORY';
    Const.GET_WITHDRAWAL_HISTORY = 'GET_WITHDRAWAL_HISTORY';
    Const.GET_BONUS_HISTORY = 'GET_BONUS_HISTORY';
    Const.GET_BANKS_DETAIL = 'GET_BANKS_DETAIL';
    Const.GET_CARDS_LIST = 'GET_CARDS_LIST';
    Const.GET_TICKET_LIST = 'GET_TICKET_LIST';
    Const.GET_DOWNLOAD_PLATFORM = 'GET_DOWNLOAD_PLATFORM';
    Const.GET_COUNTERIES = 'GET_COUNTERIES';
    Const.GET_DOCUMENT_LIST = 'GET_DOCUMENT_LIST';
    Const.GET_TICKET_VIEW_LIST = 'GET_TICKET_VIEW_LIST';
    Const.GET_DEPOSIT_ADDRESS = 'GET_DEPOSIT_ADDRESS';
    Const.GET_GRAPH_DATA = 'GET_GRAPH_DATA';
    Const.GET_CURRENT_TRADING_ACCOUNT = 'GET_CURRENT_TRADING_ACCOUNT';
    Const.GET_OPEN_ORDER = 'GET_OPEN_ORDER';
    Const.GET_MARKET_DEPTH = 'GET_MARKET_DEPTH';
    Const.GET_OPEN_HOLDINGS = 'GET_OPEN_HOLDINGS';
    Const.GET_ORDER_HISTORY = 'GET_ORDER_HISTORY';
    Const.GET_USER_LOGS = 'GET_USER_LOGS';
    Const.GET_EXCHANGE_MSG = 'GET_EXCHANGE_MSG';
    Const.GET_USER_EXTRA_INFO = 'GET_USER_EXTRA_INFO';
    Const.GET_SOCKET_INDICATOR = 'GET_SOCKET_INDICATOR';
    Const.GET_ALL_ISINS = 'GET_ALL_ISINS';
    Const.GET_SCRIP_INFO = 'GET_SCRIP_INFO';
    Const.GET_MARKET_STATUS = 'GET_MARKET_STATUS';
    Const.GET_WATCH_LIST = 'GET_WATCH_LIST';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/scalpert/provider/candle-history/lib/const.cls.ts
// module id = TxbJ
// module chunks = 73